<div class="modal">
  <div class="modal-overlay" (click)="close()"></div>

  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-body">

        <div class="m-3">
          <div class="text-center">
            <img role="img" class="" src="assets/images/ok.svg">
            <div class="fw-bold mt-3" i18n="@@OrderCheckoutResultDialogSuccessMessage">Thank you for your order! Your order has been successfully submitted and is currently being reviewed. You will shortly receive an e-mail with the confirmation. We ask for some patience. For questions we are happy to assist you. Thank you for your trust!
            </div>
          </div>
        </div>

        <div class="text-center my-3">
          <button class="btn btn-secondary btn-pretty" i18n="@@OrderCheckoutResultDialogReturnButton"
            (click)="close()">Back to home page</button>
        </div>

      </div>

    </div>
  </div>
</div>
